import { render, staticRenderFns } from "./SetStarsDialog.vue?vue&type=template&id=74ee6516&scoped=true"
import script from "./SetStarsDialog.vue?vue&type=script&lang=js"
export * from "./SetStarsDialog.vue?vue&type=script&lang=js"
import style0 from "./SetStarsDialog.vue?vue&type=style&index=0&id=74ee6516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ee6516",
  null
  
)

export default component.exports